import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Function_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODEL_FUNCTION_ID:       {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Model Function Id',       columnResourceName: 'colId',                     alignment: HorizAlignment.Left},  domainOptions: {} },
    MODEL_FUNCTION_ID:          {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Function Id',          columnResourceName: 'colId',                     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MODEL_FUNCTION_NAME:        {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Model Function Name',        columnResourceName: 'colModelFunctionName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COMMENTS:                   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Comments',                   columnResourceName: 'colComments',               alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    PREDICTOR_NUMBER_TYPE:      {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Prediction Number Type',     columnResourceName: 'colPredNumType',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CLASS_ID:                   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Class Id',                   columnResourceName: 'colClsId',                  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    FUNCTION_DEFN_JS:           {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Function Defn JS',           columnResourceName: 'colFuncDefnJS',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    COEFFICIENT_COUNT:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Coefficient Count',          columnResourceName: 'colCoeffCnt',               alignment: HorizAlignment.Left},  domainOptions: {}},
    RENDER_OPTIONS:             {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Render Options',             columnResourceName: 'colRendOpts',               alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    DELETED_IND:                {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Deleted Ind',                columnResourceName: 'colDeletedInd',             alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_DT:                 {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',               columnResourceName: 'colDeletedDate',            alignment: HorizAlignment.Left}, domainOptions: {}}
};

const ModelFunctionSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_MODEL_FUNCTION_ID',
        id_ui: 'MODEL_FUNCTION_ID',
        name:  'MODEL_FUNCTION_NAME'

    },

    searchProviderFields: vUI_Model_Function_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Function_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ModelFunctionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ModelFunctionSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_FUNCTION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_FUNCTION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_FUNCTION_ID', 'MODEL_FUNCTION_NAME','CLASS_ID',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelFunctionSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelFunctionSearch: ISearch = {
    searchName: "Find Model Function",
    renderOptions: {ui5ResourceId: "ModelFunctionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelFunctionSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelFunctionBO", "ModelFunction", ModelFunctionSearch, "Model Function Search")

export {ModelFunctionSearch}